// Print just part of the page, eg <a href="#" data-print-target="#jobPrintArea">Print Description</a>
// Hides (in print only - see .print-hide in override.css) every sibling of the target and of each of its parents,
// so the printout is just the target, starting at the top of the page with no blank space or empty pages.
$(document).on('click', '[data-print-target]', function (e) {
    e.preventDefault();

    var target = $($(this).data('print-target'));
    if (target.length) {
        target.parentsUntil('html').addBack().siblings().addClass('print-hide');
    }

    window.print();
});

window.addEventListener('afterprint', function () {
    $('.print-hide').removeClass('print-hide');
});

// Map section location tabs - keep ?location= in the address bar in step with the selected tab, so the current
// location can be copied and shared (MapSection.cshtml reads it to pick the starting tab). replaceState, so
// clicking through tabs doesn't fill up the back button history.
$(document).on('shown.bs.tab', '.location-tab[data-location]', function () {
    var location = $(this).data('location');
    if (!location || !window.history.replaceState) return;

    var url = new URL(window.location.href);
    url.searchParams.set('location', location);
    window.history.replaceState(null, '', url);
});

// ...and when a page is opened with ?location=, scroll down to the map section so the chosen location is in view.
// Waits for load so lazy images above it have settled, allows for the fixed header, and leaves #anchors to the browser.
$(window).on('load', function () {
    if (window.location.hash || !new URLSearchParams(window.location.search).get('location')) return;

    var section = $('.location-tab[data-location]').first().closest('section');
    if (!section.length) return;

    // scrollIntoView respects the html scroll-padding-top, so the section lands just below the sticky header
    section[0].scrollIntoView({ behavior: 'smooth' });
});

// Sticky header - measure it in its normal and fixed states and publish both heights as CSS variables:
// --header-height sizes the .header-spacer that holds its place while it's fixed (so the page doesn't jump), and
// --header-fixed-height is the html scroll-padding-top, so #anchor targets land just below it (override.css).
// Runs straight away so the offset is in place for the browser's initial #anchor jump, and again on load/resize.
function syncHeaderHeights() {
    var header = $('.header_sec');
    if (!header.length) return;

    var wasFixed = header.hasClass('fixed');

    header.removeClass('fixed');
    var normalHeight = header.outerHeight();

    header.addClass('fixed');
    var fixedHeight = header.outerHeight();

    header.toggleClass('fixed', wasFixed);

    document.documentElement.style.setProperty('--header-height', normalHeight + 'px');
    document.documentElement.style.setProperty('--header-fixed-height', fixedHeight + 'px');
}

syncHeaderHeights();
$(window).on('load resize', syncHeaderHeights);

// The frontend's custom single-select (.select_field, carouselscript.js) sets the hidden <select> and triggers change,
// but jQuery Validate doesn't re-check a select on change - re-validate it so a "required" message clears straight away
$(document).on('change', '.select_field select', function () {
    var form = $(this).closest('form');
    if (form.length && form.data('validator')) {
        $(this).valid();
    }
});
